import api from "../api";

export const updateProductionPartnerKey = async (workspace_id, payload) => {
  return api
    .post(`/v0/partner/${workspace_id}/credentials/production`,
        {
            ...payload, 
            environment: "production"
        }
    ).then((response) => response.data);
};

export const updateSandboxPartnerKey = async (workspace_id, payload) => {
  return api
    .post(`/v0/partner/${workspace_id}/credentials/sandbox`,
        {
            ...payload, 
            environment: "sandbox"
        }
    ).then((response) => response.data);
};
